/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

function checkCartItems() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      const checkoutButton = document.querySelector('button[name="checkout"]');
      const popup = document.getElementById('inquiry-popup');
      const closeButton = document.querySelector('.close-btn');
      
      // カート内の各アイテムをチェック
      let anyItemExceedsLimit = false;
      cart.items.forEach(item => {
        if (item.quantity >= 10) {
          anyItemExceedsLimit = true;
          return; // 10個以上のアイテムが見つかったらループを終了
        }
      });

      if (anyItemExceedsLimit) {
        // カート内のどれかのアイテムが10個以上の場合の処理
        checkoutButton.addEventListener('click', function(event) {
          event.preventDefault();
          popup.style.display = 'flex';
        });

        closeButton.onclick = function() {
          popup.style.display = 'none';
        }
      } else {
        // カート内のすべてのアイテムが10個未満の場合の処理
        const newButton = checkoutButton.cloneNode(true);
        checkoutButton.parentNode.replaceChild(newButton, checkoutButton);
      }
    });
}

// ページのロード時にカートをチェック
checkCartItems();

// 商品がカートに追加された場合にカートを再チェック
document.addEventListener('product:added', checkCartItems);

// テーマのロードが完了した場合にもカートを再チェック
document.addEventListener('theme:loading:end', checkCartItems);
